import { IsNumber, IsString } from "class-validator";
import { Expose } from "class-transformer";

export default class InformationAboutCorrectedItem {
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  ordinal!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  reservationNumber!: string;
  @IsString()
  @Expose()
  ticketNumber!: string;

  constructor(val?: InformationAboutCorrectedItem) {
    if (!val) return;
    this.documentNumber = val.documentNumber || "";
    this.grossInCurrency = val.grossInCurrency || 0;
    this.ordinal = val.ordinal || 0;
    this.name = val.name || "";
    this.reservationNumber = val.reservationNumber || "";
    this.ticketNumber = val.ticketNumber || "";
  }
}
